import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const SupportTicketsListView = lazy(() =>
	import('./components/views/SupportTicketsListView').then((module) => ({
		default: module.SupportTicketsListView
	}))
);

const supportTicketsRoutes: FuseRouteItemType[] = [
	{
		path: 'support-tickets',
		element: <SupportTicketsListView />
	}
];

export default supportTicketsRoutes;
